__turbopack_context__.v({
  "accordionSlideOverwrite": "infoCard-module-scss-module__IlrMHq__accordionSlideOverwrite",
  "dismiss": "infoCard-module-scss-module__IlrMHq__dismiss",
  "error": "infoCard-module-scss-module__IlrMHq__error",
  "fadeIn": "infoCard-module-scss-module__IlrMHq__fadeIn",
  "fadeOut": "infoCard-module-scss-module__IlrMHq__fadeOut",
  "icon": "infoCard-module-scss-module__IlrMHq__icon",
  "info": "infoCard-module-scss-module__IlrMHq__info",
  "infoCard": "infoCard-module-scss-module__IlrMHq__infoCard",
  "scaleIn": "infoCard-module-scss-module__IlrMHq__scaleIn",
  "scaleOut": "infoCard-module-scss-module__IlrMHq__scaleOut",
  "success": "infoCard-module-scss-module__IlrMHq__success",
  "warning": "infoCard-module-scss-module__IlrMHq__warning",
  "zoomIn": "infoCard-module-scss-module__IlrMHq__zoomIn",
  "zoomOut": "infoCard-module-scss-module__IlrMHq__zoomOut",
});
